// @flow

import * as React from "react";

import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import SectionHeader from "../molecules/SectionHeader";
import TextButton from "../atoms/TextButton";
import Icon from "../atoms/Icon";
import ReactFormFiedRTE from "../atoms/ReactFormFieldRTE";

type PropsType = {
    accordions?: [any],
    title?: string | React.Node,
    description?: string,
    onUpdate?: any,
    ref?: any,
};

const EditableAccordions = (props: PropsType): React.Node => {
    const formRef = React.useRef(null);
    const [accordionList, setAccordionList] = React.useState(
        props.defaultValue || [
            {
                title: "",
                content: "",
            },
        ]
    );

    const validateForm = () => {
        if (formRef.current) {
            formRef.current.submit();
        }
    };
    if (props.customRef && props.customRef.current) {
        props.customRef.current.validateForm = validateForm;
    }

    const addNewAccordion = () => {
        const list = accordionList;
        setAccordionList([
            ...list,
            {
                title: "",
                content: "",
            },
        ]);
    };

    const removeAccordion = key => {
        const list = accordionList;
        list.splice(key, 1);
        setAccordionList([...list]);
    };

    const handleQuestionEdit = (value, label, id) => {
        const list = accordionList;
        list[id][label] = value;
        setAccordionList([...list]);
    };

    React.useEffect(() => {
        if (props.onUpdate) {
            const formValid = formRef.current.formValid;

            props.onUpdate(accordionList, formValid);
        }
    }, [accordionList]); // eslint-disable-line

    return (
        <div className="accordions">
            {props.title || props.description ? (
                <SectionHeader
                    sectionName="accordions"
                    title={props.title}
                    description={props.description}
                />
            ) : null}
            <div className="accordions__content">
                {
                    //  props.accordions.map(
                    //     (accordion: any, index: number): React.Node => (
                    //         <Accordion key={index} {...accordion} />
                    //     )
                    // )
                }
                <ReactForm ref={formRef}>
                    {accordionList.map((accordion, key) => {
                        return (
                            <div
                                key={key}
                                className={`editable-accordion ${
                                    props.disabled
                                        ? "editable-accordion--disabled"
                                        : ""
                                }`}
                            >
                                <div className="editable-accordion__header">
                                    <div className="editable-accordion__header__title">
                                        Question
                                    </div>
                                    <TextButton
                                        type="button"
                                        className="editable-accordion__header__remove"
                                        onClick={() => removeAccordion(key)}
                                        disabled={props.disabled}
                                    >
                                        Remove
                                    </TextButton>
                                </div>
                                <div className="editable-accordion__body">
                                    <ReactFormField
                                        type="text"
                                        label="Question"
                                        name={`title_${key}`}
                                        value={accordion.title}
                                        onChange={e =>
                                            handleQuestionEdit(
                                                e.target.value,
                                                "title",
                                                key
                                            )
                                        }
                                        required={true}
                                        disabled={props.disabled}
                                    />
                                    <div className="editable-accordion__body__label">
                                        Answer
                                    </div>
                                    <ReactFormField
                                        fieldComponent={ReactFormFiedRTE}
                                        type="text"
                                        name={`content_${key}`}
                                        height={170}
                                        value={accordion.content}
                                        onChange={e =>
                                            handleQuestionEdit(
                                                e.target.value,
                                                "content",
                                                key
                                            )
                                        }
                                        required={true}
                                        disabled={props.disabled}
                                    />
                                    {/* <Editor
                                        // initialValue="<p>This is the initial content of the editor.</p>"
                                        init={tinyMCEConfig}
                                        value={accordion.content}
                                        onEditorChange={(value, editor) =>
                                            handleQuestionEdit(
                                                value,
                                                "content",
                                                key
                                            )
                                        }
                                    /> */}
                                </div>
                            </div>
                        );
                    })}

                    {!props.disabled ? (
                        <TextButton
                            type="button"
                            className="editable-accordion__add"
                            onClick={addNewAccordion}
                        >
                            <Icon name="plus-circle" />
                            <span>Add another question</span>
                        </TextButton>
                    ) : null}
                </ReactForm>
            </div>
        </div>
    );
};

export default EditableAccordions;
